import styled from "styled-components";

const OfficeLocationContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 150px 95px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: ${(props) => props.theme.colors.primary.contrast};
  .office-location-title {
    color: ${(props) => props.theme.colors.primary.black};
    font-family: Mulish;
    font-size: 100px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
    margin: 0;
  }
  .office-location-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }
  .office-location-intro {
    display: flex;
    padding-bottom: 100px;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-bottom: 2px solid #a8b9ca;
  }
  .offices {
    display: flex;
    max-width: 1720px;
    padding-top: 100px;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }
  .offices-left-column {
    display: flex;
    align-items: center;
    gap: 50px;
    flex: 1 0 0;
    width: 100%;
  }
  .offices-rectangle {
    width: 10%;
    height: 5px;
    background: ${(props) => props.theme.colors.primary.main};
  }
  .our-offices {
    color: ${(props) => props.theme.colors.primary.darkBlue};
    font-family: Mulish;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    margin: 0;
  }
  .offices-right-column-desktop {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 50px;
  }
  .offices-locations-row {
    display: flex;
    padding-bottom: 40px;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    border-bottom: 1px solid ${(props) => props.theme.colors.primary.black};
  }
  .offices-locations-row-gurgaon {
    border-bottom: 0;
  }
  .offices-locations {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }
  .offices-locations-column-left {
    display: flex;
    width: 100%;
    max-width: 600px;
    padding-right: 25px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-right: 1px solid ${(props) => props.theme.colors.primary.black};
  }
  .offices-locations-column-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
  }
  .offices-locations-image {
    width: 100%;
    max-width: 275px;
    height: 115px;
  }
  .offices-locations-text-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    flex: 1 0 0;
    align-self: stretch;
  }
  .offices-locations-city-title {
    color: ${(props) => props.theme.colors.primary.black};
    font-family: Mulish;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    text-transform: uppercase;
    margin: 0;
  }
  .offices-locations-city-description {
    color: ${(props) => props.theme.colors.primary.black};
    font-family: Mulish;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
  }
  .offices-locations-column-right {
    display: flex;
    width: 100%;
    max-width: 600px;
    padding-left: 25px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .offices-right-column-row-mobile {
    display: none;
  }
  @media (max-width: 1500px) {
    .offices {
      flex-direction: column;
    }
    .offices-left-column {
      margin-bottom: 40px;
    }
  }
  @media (max-width: 1400px) {
    .offices-locations-image {
      width: 50%;
      height: auto;
    }
  }
  @media screen and (max-width: 1023px) {
    display: flex;
    padding: 100px 0px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    .office-location-column {
      display: flex;
      padding: 0px 30px;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
      align-self: stretch;
    }
    .office-location-intro {
      display: flex;
      padding-bottom: 50px;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
    }
    .office-location-title {
      color: ${(props) => props.theme.colors.primary.black};
      font-family: Mulish;
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    .offices {
      display: flex;
      padding-top: 30px;
      flex-direction: column;
      align-items: flex-end;
      gap: 20px;
      align-self: stretch;
    }
    .offices-left-column {
      display: flex;
      padding-bottom: 20px;
      align-items: center;
      gap: 20px;
      align-self: stretch;
      margin-bottom: 0;
    }
    .offices-rectangle {
      width: 50px;
      height: 5px;
    }
    .our-offices {
      color: ${(props) => props.theme.colors.primary.darkBlue};
      font-family: Mulish;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin: 0;
    }
    .offices-right-column-desktop {
      display: none;
    }

    .offices-right-column-row-mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
      align-self: stretch;
      border-bottom: 1px solid ${(props) => props.theme.colors.primary.black};
    }

     .offices-right-column-row-mobile-5 {
      border-bottom: 0;
    }

    .offices-right-column-item-mobile {
      display: flex;
      padding-bottom: 20px;
      align-items: flex-start;
      gap: 15px;
      align-self: stretch;
    }

    .offices-right-column-container-mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 1 0 0;
    }

    .offices-locations-city-title-mobile {
      color: ${(props) => props.theme.colors.primary.darkGray};
      font-family: Mulish;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%;
      text-transform: uppercase;
      margin: 0;
      margin-bottom: 5px;
    }
    .offices-locations-city-description-mobile {
      color: ${(props) => props.theme.colors.primary.darkGray};
      font-family: Mulish;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      margin: 0;
    }
`;

export default OfficeLocationContainer;
